import { AlignmentType, Paragraph, TextRun } from "docx"


export const observationAudit1 = new Paragraph({
    spacing: { before: 350, after:250 },
    children: [
        new TextRun({
            text: "This section of the report provides mitigation steps for the identified vulnerabilities.",
            size: 24,
            color: "000000",
            font: "Arial",
            bold: false,
            italics:false
        })
    ],
})

export const observationAudit2 = new Paragraph({
    spacing: { before: 50, after:250 },
    alignment: AlignmentType.JUSTIFIED,
    children: [
        new TextRun({
            text: "The tables below list the vulnerabilities identified, their Severity, Detailed observation and the remediation actions to be performed. The scale as mentioned in Section 9.0 has been used to rate the severity.",
            size: 24,
            color: "000000",
            font: "Arial",
            bold: false,
            italics:false
        })
    ],
})

export const observationAudit3 = new Paragraph({
    spacing: { before: 450, after:250 },
    alignment: AlignmentType.JUSTIFIED,
    children: [
        new TextRun({
            text: "The remediation measures that are listed below should not be implemented on the production systems without prior testing and processing through the proper change management process.",
            size: 24,
            color: "000000",
            font: "Arial",
            bold: true,
            italics:false
        })
    ],
})
